<template>
  <div class="d-flex pb-2 justify-end mb-2">
    <slot name="top-search-area" />
  </div>
  <div class="d-flex pb-2 justify-space-between">
    <div class="d-flex align-center justify-start" style="width: 50%">
      <p class="font-weight-medium mr-1" style="color: grey">Total Count:</p>
      <p class="font-weight-bold mr-5" style="color: grey; font-size: 13px">{{ totalCnt }}</p>
      <v-select
        v-if="!hideRowPerPage"
        :items="rowsPerPageOptions"
        v-model="selectedRowPerPage"
        style="width: 180px; flex: inherit"
      />
    </div>
    <div class="d-flex align-center justify-end" style="width: 50%">
      <!-- template v-slot:top-btn-area (S) -->
      <slot name="top-btn-area"></slot>
      <!-- template v-slot:top-btn-area (E) -->
    </div>
  </div>

  <v-divider />

  <div class="d-flex py-2 justify-space-between">
    <div class="d-flex align-center justify-start" style="width: 50%">
      <!-- template v-slot:left-btn-area (S) -->
      <div class="d-flex align-center justify-start">
        <!-- checked 상태일 때만 나오는 체크된 갯수 -->
        <p v-if="checked" class="font-weight-medium mr-2" style="color: grey">
          {{ validationCheckedCnt }}
        </p>
        <slot name="left-btn-area"> </slot>
      </div>
      <!-- template v-slot:left-btn-area (E) -->
    </div>
    <div class="d-flex align-center justify-end" style="width: 50%">
      <!-- template v-slot:right-btn-area (S) -->
      <slot name="right-btn-area"></slot>
      <!-- template v-slot:right-btn-area (E) -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { i18n } from "@/common/plugins/global.ts";

/* ------------------------------------------------------------
                          Vue Instance & Global Properties
   ------------------------------------------------------------ */
const { $text } = i18n();

/* ------------------------------------------------------------
                          Model
   ------------------------------------------------------------ */
const selectedRowPerPage = defineModel("rowPerPage", { type: Number, required: true });

/* ------------------------------------------------------------
                          Props
   ------------------------------------------------------------ */
const props = defineProps({
  totalCnt: { type: Number, required: true },
  checked: { type: Boolean, default: false },
  checkedCnt: { type: Number, default: 0 },
  hideRowPerPage: { type: Boolean, default: false },
});

/* ------------------------------------------------------------
                          Variable Declarations
   ------------------------------------------------------------ */
/** 행 수 옵션 */
const rowsPerPageOptions = [
  { title: $text("table.row5"), value: 5 },
  { title: $text("table.row10"), value: 10 },
  { title: $text("table.row50"), value: 50 },
  { title: $text("table.row100"), value: 100 },
];

/** 선택된 갯수 가져오기 */
const validationCheckedCnt = computed(() => {
  return props.checked ? `${props.checkedCnt}개 선택` : "";
});
</script>
